package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ScrollSnapAlign
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.SVGFillType
import com.varabyte.kobweb.compose.dom.svg.SVGStrokeLineCap
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowDefaults
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.CheckboxKind
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.link
import com.varabyte.kobweb.silk.style.selectors.visited
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.color.ColorVar
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.colorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.example.site_web.SitePalette
import org.example.site_web.SitePalettes
import org.example.site_web.aiPalette
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Span
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

val FooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(Colors.Black)
        .padding(topBottom = 0.5.cssRem, leftRight = 10.percent)
}

val MenuFooterStyle = CssStyle{
    base {
        Modifier.whiteSpace(WhiteSpace.NoWrap)
            .color(aiPalette.optPalette.primary)
            .textDecorationLine(TextDecorationLine.Underline)
    }
    link {
        Modifier.color(aiPalette.optPalette.primary)
    }
    visited {
        Modifier.color(aiPalette.optPalette.primary)
    }
    hover {
        Modifier.color(aiPalette.mainPalette.primary)

    }
    active {
        Modifier.color(aiPalette.optPalette.primary)
    }
}


val BzhLogoStyle = CssStyle {
    base{
        Modifier.visibility(Visibility.Hidden)
    }

    hover{
        Modifier.visibility(Visibility.Visible)
    }
//    .bzhlogo:hover{
//    .backgroundColor(colorMode.toSitePalette().nearBackground)
//    .padding(topBottom = 0.5.cssRem, leftRight = 10.percent)
//}
}

@Composable
fun BreizhSoutienBloc(){
    var infoVisibility by remember { mutableStateOf(false) }

    Box(Modifier
        .padding(1.cssRem), contentAlignment = Alignment.Center) {

        A(href = "#", Modifier.id("bzhlogo").toAttrs()) {
            Img(src = "/assets/logo_bzh_acc.png",
                alt="Avec le soutien de la Région Bretagne")
//                attrs = Modifier
//                    .maxWidth(100.px)
//                    .toAttrs())
        }
        val visib = if(infoVisibility) Visibility.Visible else Visibility.Hidden
        Box(Modifier.visibility(visib)
            .onMouseOver { infoVisibility = true }
            .onMouseOut { infoVisibility = false }
            .borderRadius(0.5.cssRem)
            .border{
                style(LineStyle.Solid)
                color(aiPalette.optPalette.primary)
            }
            .backgroundColor(aiPalette.darkBackColor)
            .padding(0.5.cssRem)
            .color(Colors.White),
            contentAlignment = Alignment.Center
        )
        {
            Text("Au sein d'Emergys Bretagne")
            Br()
            Text("Incubateur d'entreprises innovantes")
        }
    }
}



@Composable
fun Footer(modifier: Modifier ) {
            Column( modifier
                .backgroundColor(Colors.Black)
                .color(aiPalette.optPalette.primary)
                .padding(topBottom = 0.75.cssRem)
                .fillMaxWidth()
                .borderTop{
                    color(aiPalette.optPalette.primary)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .fontSize(0.8.cssRem),horizontalAlignment = Alignment.CenterHorizontally) {
            Span(Modifier
                .margin(leftRight = 1.cssRem)
                .textAlign(TextAlign.Center)
                .fontStyle(FontStyle.Italic).toAttrs {  }) {
                Text("ACCELARGE\u00a0INNOVATIONS, 15\u00a0rue\u00a0Galilée, Espace\u00a0CREA, Parc\u00a0Technologique\u00a0de\u00a0Soye, 56270\u00a0PLOEMEUR, FR-56")
                Br()
                Text("contact@accelarge.com")
            }
            Row(Modifier
                .displayIfAtLeast(Breakpoint.MD),horizontalArrangement = Arrangement.spacedBy(2.cssRem)) {
                Link(
                    "/legal-notice", "Mentions Légales", MenuFooterStyle.toModifier()
                )
                Link(
                    "/website-credits", "A propos de ce site", MenuFooterStyle.toModifier()
                )
                Link(
                    "https://kobweb.varabyte.com/", "Créé avec Kobweb", MenuFooterStyle.toModifier()
                )
            }
                Column(Modifier.displayUntil(Breakpoint.MD)
                    .margin(0.5.cssRem),
                    verticalArrangement = Arrangement.spacedBy(0.5.cssRem),
                    horizontalAlignment = Alignment.CenterHorizontally) {
                    Link(
                        "/legal-notice", "Mentions Légales", MenuFooterStyle.toModifier()
                    )
                    Link(
                        "/website-credits", "A propos de ce site", MenuFooterStyle.toModifier()
                    )
                    Link(
                        "https://kobweb.varabyte.com/", "Crée avec Kobweb", MenuFooterStyle.toModifier()
                    )
                }
    }
//    Column(
//        modifier
//            .padding(topBottom = 0.75.cssRem)
//            .gap(0.5.cssRem)
//            , horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//
//    }

}
